import React from 'react';
import classnames from 'classnames';

import { useParentMarkStore } from 'store/parent/useParentMarkStore';

const Tab = ({ childId, grade }) => {
	// Use parent's mark store
	const [active, onActive] = useParentMarkStore(state => [
		state.children.find(child => child.id === childId)?.active,
		state.onActive
	]);

	// Concat tab classname
	const cls = classnames(
		'py-2 px-4 text-neutral-700 dark:text-neutral-200 hover:bg-neutral-50 dark:hover:bg-neutral-700 rounded-lg cursor-pointer',
		active === grade.id && 'bg-neutral-50 dark:bg-neutral-700'
	);

	// Handle tab click
	const onClick = () => onActive(childId, grade.id);

	return (
		<div className={cls} onClick={onClick}>
			{grade.title}
		</div>
	);
};

export default Tab;